module.exports = "/_next/static/images/coins-duotone-7dd7fd3d539f500163a1adaf57481a8d.svg";